import React from 'react';
import ContainerTemplate from '../../../widgets/template/Container';
import MateriasView from './MateriasView';
import * as ROUTES from '../../../router/Routes';

const MateriasModule = () => {
  return (
    <ContainerTemplate
      active={ROUTES.materias}
      routes={[ROUTES.controlEstudios]}
    >
      <MateriasView />
    </ContainerTemplate>
  );
};

export default MateriasModule;
